import { Image as ImageIconLucide, UploadCloud, X } from "lucide-react";

export default function FileDrop({ file, onPick, inputRef, testId }) {
  return (
    <label
      data-testid={testId}
      className={`relative flex items-center justify-center w-full rounded-lg border-2 border-dashed transition cursor-pointer ${file ? "border-[#D4AF37]/40 bg-[#141414]" : "border-white/10 hover:border-white/30 bg-[#0A0A0A]"}`}
      style={{ minHeight: 120 }}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={(e) => onPick(e.target.files?.[0] || null)}
        className="absolute inset-0 opacity-0 cursor-pointer"
      />
      {file ? (
        <div className="flex items-center gap-3 px-4 py-3">
          <ImageIconLucide className="w-4 h-4 text-[#D4AF37]" />
          <span className="text-xs text-white/85 truncate max-w-[20ch]">{file.name}</span>
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); onPick(null); if (inputRef.current) inputRef.current.value = ""; }}
            className="text-white/55 hover:text-white"
            aria-label="Clear file"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-1 px-4 py-3">
          <UploadCloud className="w-5 h-5 text-white/55" />
          <span className="text-[11px] text-white/55">Drop file or click to upload</span>
        </div>
      )}
    </label>
  );
}
